export const CONSENT_COOKIES = {
  ANALYTICS: 'analytics',
  ADVERTISING: 'advertising',
  FUNCTIONALITY: 'functionality',
};
